/* ============================================
   CATALOG DATA — Zones, transitions, constantes
   ============================================
   Source de verite : doc/TEMPLATE_ENGINE_SPEC.md
   Approche : TOUTES les combinaisons from→to
   sont generees. L'utilisateur les categorise.
   ============================================ */

// ── Zones du terrain (coordonnees normalisees 0-1) ──
// x: gauche(0) = but propre, droite(1) = but adverse
// y: haut(0) = touche haute, bas(1) = touche basse
// flanks: true = zone dupliquee haut + bas

export const ZONES = {
  D1: { label: "6m propre",       x: [0.00, 0.05], y: [0.30, 0.70], flanks: false },
  C1: { label: "Surface propre",  x: [0.05, 0.17], y: [0.19, 0.81], flanks: false },
  B:  { label: "Relance basse",   x: [0.17, 0.33], y: [0.19, 0.81], flanks: false },
  A1: { label: "Couloir coin propre",     x: [0.00, 0.17], y: [0.00, 0.19], flanks: true },
  A2: { label: "Couloir relance",         x: [0.17, 0.33], y: [0.00, 0.19], flanks: true },
  A3: { label: "Couloir constr. propre",  x: [0.33, 0.50], y: [0.00, 0.19], flanks: true },
  A4: { label: "Couloir constr. adverse", x: [0.50, 0.67], y: [0.00, 0.19], flanks: true },
  A5: { label: "Couloir attaque",         x: [0.67, 0.83], y: [0.00, 0.19], flanks: true },
  A6: { label: "Couloir coin adverse",    x: [0.83, 1.00], y: [0.00, 0.19], flanks: true },
  E1: { label: "Half-space propre",       x: [0.33, 0.50], y: [0.19, 0.35], flanks: true },
  E2: { label: "Half-space adverse",      x: [0.50, 0.67], y: [0.19, 0.35], flanks: true },
  E3: { label: "Half-space surface",      x: [0.67, 0.83], y: [0.19, 0.35], flanks: true },
  F1: { label: "Axe rond central propre", x: [0.33, 0.50], y: [0.35, 0.65], flanks: false },
  F2: { label: "Axe rond central adverse",x: [0.50, 0.67], y: [0.35, 0.65], flanks: false },
  F3: { label: "Axe 30 derniers m.",      x: [0.67, 0.80], y: [0.35, 0.65], flanks: false },
  G:  { label: "Zone de frappe",          x: [0.80, 0.85], y: [0.35, 0.65], flanks: false },
  C2: { label: "Surface adverse",         x: [0.85, 0.95], y: [0.19, 0.81], flanks: false },
  D2: { label: "6m adverse",              x: [0.95, 1.00], y: [0.30, 0.70], flanks: false },
}

export const ZONE_IDS = Object.keys(ZONES)

// ── Categories (tags assignables par l'utilisateur) ──

export const CATEGORIES = [
  { id: "relance",              label: "Relance (sortie de balle)" },
  { id: "construction_propre",  label: "Construction (propre camp)" },
  { id: "progression",          label: "Progression (passage milieu)" },
  { id: "construction_adverse", label: "Construction (camp adverse)" },
  { id: "approche",             label: "Approche (zone dangereuse)" },
  { id: "zone_dangereuse",      label: "Zone dangereuse (derniers gestes)" },
  { id: "centres",              label: "Centres" },
  { id: "recul",                label: "Recul (jeu vers l'arriere)" },
  { id: "switch_flanc",         label: "Switch de flanc (renversement)" },
  { id: "passes_longues",       label: "Passes longues (saut 2+ zones)" },
  { id: "meme_zone",            label: "Meme zone (temporisation)" },
  { id: "tirs",                 label: "Tirs" },
  { id: "coups_arretes",        label: "Coups de pied arretes" },
  { id: "resolution",           label: "Resolution (fin de phase)" },
  { id: "non_categorise",       label: "Non categorise" },
]

// ── Actions possibles ──

export const ACTIONS = [
  "PASS", "DRIBBLE", "CROSS", "SHOT_ON", "SHOT_OFF", "SHOT_BLOCKED",
  "CLEARANCE", "GOAL_KICK", "FREE_KICK", "CORNER", "THROW_IN",
  "TACKLE", "INTERCEPTION",
]

// ── Types d'événements pour templates event-based (P1 + P2) ──

export const EVENT_TYPES = [
  // P1 — Événements standards
  { id: "Corner",                    label: "Corner",                  priority: 1 },
  { id: "Frappe cadrée",             label: "Frappe cadrée",           priority: 1 },
  { id: "Frappe non cadrée",         label: "Frappe non cadrée",       priority: 1 },
  { id: "Carton jaune",              label: "Carton jaune",            priority: 1 },
  { id: "Coup franc",                label: "Coup franc",              priority: 1 },
  { id: "Coup franc dangereux",      label: "Coup franc dangereux",    priority: 1 },
  { id: "Touche",                    label: "Touche",                  priority: 1 },
  { id: "6 mètres",                  label: "6 mètres",               priority: 1 },
  { id: "Hors-jeu",                  label: "Hors-jeu",               priority: 1 },
  { id: "Remplacement",              label: "Remplacement",            priority: 1 },
  { id: "Coup d'envoi",              label: "Coup d'envoi",            priority: 1 },
  { id: "Coup d'envoi 2ème mi-temps", label: "Coup d'envoi 2ème MT",  priority: 1 },
  // P2 — Moments majeurs
  { id: "But",                       label: "But",                     priority: 2 },
  { id: "Carton rouge",              label: "Carton rouge",            priority: 2 },
  { id: "Penalty",                   label: "Penalty",                 priority: 2 },
  { id: "Penalty manqué",            label: "Penalty manqué",          priority: 2 },
  { id: "VAR",                       label: "VAR",                     priority: 2 },
  { id: "Mi-temps",                  label: "Mi-temps",                priority: 2 },
  { id: "Fin du match",              label: "Fin du match",            priority: 2 },
]

export const EVENT_TYPE_IDS = EVENT_TYPES.map(e => e.id)

// ── Positions dans la phase ──

export const PHASE_POSITIONS = [
  "START", "BUILD_UP", "PROGRESSION", "DANGER", "CLIMAX", "RESOLUTION",
]

// ── Variables disponibles dans les templates ──

export const TEMPLATE_VARIABLES = [
  { key: "player",     desc: "Joueur actuel (gardien inclus)" },
  { key: "prevPlayer", desc: "Joueur precedent" },
  { key: "team",       desc: "Nom equipe" },
  { key: "opponent",   desc: "Equipe adverse" },
  { key: "side",       desc: "gauche / droit" },
  { key: "zone",       desc: "Zone en langage naturel" },
  { key: "minute",     desc: "Minute de jeu" },
  { key: "score",      desc: "Score actuel" },
  { key: "lostBy",    desc: "Joueur qui a perdu le ballon (apres turnover)" },
]

// ── Generation de toutes les transitions zone-a-zone ──
// to = null signifie "premiere touche" (debut de possession dans la zone)

export function generateAllTransitions() {
  const transitions = []
  for (const from of ZONE_IDS) {
    for (const to of ZONE_IDS) {
      transitions.push({ from, to })
    }
  }
  return transitions
}

// ── Grouper les transitions par zone de depart ──
// Premiere touche (to=null) en tete, puis meme zone, puis les autres

export function getTransitionsByFromZone() {
  const groups = {}
  for (const from of ZONE_IDS) {
    groups[from] = {
      zone: from,
      label: ZONES[from].label,
      transitions: [
        { from, to: null },  // premiere touche
        ...ZONE_IDS.map((to) => ({ from, to })),
      ],
    }
  }
  return groups
}

// ── Cle unique d'une transition ──

export function getTransitionKey(from, to) {
  if (to === null) return `${from}>_FT`
  return `${from}>${to}`
}

/**
 * Transitions qui réutilisent les mêmes templates (et meta par défaut) qu'une autre paire from→to.
 * Clé = getTransitionKey(from, to) ; valeur = la transition « source » à dupliquer.
 */
export const TRANSITION_TEMPLATE_ALIASES = {
  "B>C1": { from: "B", to: "D1" },
  "B>A6": { from: "B", to: "A5" },
  "B>F1": { from: "B", to: "E1" },
}

/** @returns {{ from: string, to: string } | null} */
export function getTransitionTemplateAlias(from, to) {
  const key = getTransitionKey(from, to)
  return TRANSITION_TEMPLATE_ALIASES[key] || null
}
